// Margem de segurança pra impressão térmica (58mm/80mm) — cada COMPUTADOR
// guarda a sua, salva no navegador (localStorage), não no servidor. A
// impressora térmica é física, ligada numa máquina específica; duas caixas
// da mesma loja podem ter modelos diferentes, e cada driver de impressora
// reporta uma área imprimível real diferente (muita "80mm" só imprime uns
// 72-76mm de verdade) — por isso não dá pra ter um valor único pra
// organização inteira. Ver impressaoVenda.js pra onde isso é usado.
const CHAVE = 'impressao_margem_mm';

export function getMargemImpressaoMM() {
  const v = parseFloat(localStorage.getItem(CHAVE));
  return Number.isFinite(v) && v >= 0 ? v : 0;
}

export function setMargemImpressaoMM(mm) {
  const v = Math.max(0, Math.min(20, parseFloat(mm) || 0));
  localStorage.setItem(CHAVE, String(v));
  return v;
}

// '58mm'/'80mm' (ou qualquer '<n>mm') → largura efetiva já descontando a
// margem de CADA lado (2×) — ex.: 80mm com margem 4mm vira '72mm'. Nunca
// desce de 20mm (trava contra erro de digitação absurdo).
export function larguraEfetivaCSS(largura) {
  const nominal = parseFloat(largura) || 80;
  const efetiva = Math.max(20, nominal - getMargemImpressaoMM() * 2);
  return `${efetiva}mm`;
}
